import React from "react";
import { Controller } from "react-hook-form";

const CurrencyInput = ({
  className,
  error,
  label,
  name,
  control,
  required = false,
  type = "text",
  readOnly = false,
  disabled = false,
  register,
  ...props
}) => {
  const { onChange: onChangeProp, ...restProps } = props;

  return (
    <div className={`relative ${className}`}>
      <Controller
        control={control}
        name={name}
        rules={{ required }}
        render={({ field: { onChange, onBlur, value, ref } }) => {
          const numericValue = parseFloat(value) || 0;
          const formattedValue =
            value || value === "0"
              ? numericValue.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              : "";

          const handleChange = (e) => {
            const inputValue = e.target.value;
            const digits = inputValue.replace(/\D/g, "");
            if (digits === "") {
              onChange("");
              return;
            }
            const parsed = parseFloat(digits) / 100;
            // Passa para o formulário o valor limpo com ponto como separador
            onChange(parsed.toFixed(2));
          };

          return (
            <>
              <input
                type={type}
                id={name}
                name={name}
                ref={ref}
                value={formattedValue}
                onChange={(e) => {
                  handleChange(e);
                  if (onChangeProp) onChangeProp(e);
                }}
                onBlur={onBlur}
                readOnly={readOnly}
                disabled={disabled}
                placeholder=""
                className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 
                  bg-transparent rounded-lg border border-gray-300 
                  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 
                  focus:outline-none focus:ring-0 peer"
                {...restProps}
              />
              {label && (
                <label
                  htmlFor={name}
                  className="left-1 absolute text-md text-gray-500 dark:text-gray-400 duration-300 
                    transform -translate-y-5 scale-75 top-2 z-10 origin-[0] bg-white 
                    dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-gray-600 
                    peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 
                    peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 
                    peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 pointer-events-none"
                >
                  {label}
                </label>
              )}
            </>
          );
        }}
      />
      {error && <small className="text-red-400">{error}</small>}
    </div>
  );
};

export default CurrencyInput;
